// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"u5wJdy2","menuItemText":"v3BG_m3","counter":"_3SyOK5N","topLevelLink":"_1Iza7zH"};